import React from 'react';

/**
 * Editor fuer eine Liste von Unteraufgaben (Titel-Zeilen mit Hinzufuegen/Entfernen).
 * Wird von der Aufgaben- und der Vorlagen-Form genutzt.
 *
 * @param {{ items: Array<{titel: string}>, onChange: (items) => void }} props
 */
export default function UnteraufgabenEditor({ items, onChange }) {
  const setTitel = (index, titel) => {
    onChange(items.map((u, i) => (i === index ? { ...u, titel } : u)));
  };

  const entferne = (index) => {
    onChange(items.filter((_, i) => i !== index));
  };

  const fuegeHinzu = () => {
    onChange([...items, { titel: '', erledigt: false }]);
  };

  return (
    <div className="space-y-2">
      {items.map((u, i) => (
        <div key={i} className="flex items-center gap-2">
          <span className="text-ink-muted">•</span>
          <input
            type="text"
            value={u.titel}
            onChange={(e) => setTitel(i, e.target.value)}
            placeholder="Unteraufgabe…"
            className="flex-1 rounded-lg border border-line bg-paper-soft px-3 py-1.5 text-sm text-ink outline-none focus:border-brand-500"
          />
          <button
            type="button"
            onClick={() => entferne(i)}
            className="rounded-lg px-2 py-1 text-ink-muted transition-colors hover:bg-loss/10 hover:text-loss"
            aria-label="Unteraufgabe entfernen"
          >
            ✕
          </button>
        </div>
      ))}
      <button
        type="button"
        onClick={fuegeHinzu}
        className="text-sm font-medium text-brand-700 transition-colors hover:text-brand-500"
      >
        + Unteraufgabe
      </button>
    </div>
  );
}
